var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-events-details-view"},[_c('HubCalendarDetail',{attrs:{"content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }